/* eslint-disable react/no-children-prop */
import { Badge, Box, Flex, Text } from "@chakra-ui/react";
import { Feature } from "geojson";
import L from "leaflet";
import { useMap } from "react-leaflet";
import { useNavigate } from "react-router-dom";
import { RiArrowRightLine } from "react-icons/ri";
import { IconButtonGray } from "components/Atomos/Buttons/IconButtonGray";
import { TextGray } from "components/Atomos/Texts/TextGray";
import { useCamadas } from "../../contexts/CamadasProvider";

export type ResultadoBusca = {
  id: string;
  sigla: string;
  nome: string;
  tipo: string;
  origem: "zona" | "area";
  feature: Feature;
};

export const ItemResult = ({
  data,
  index,
  style
}: {
  data: ResultadoBusca[];
  index: number;
  style: React.CSSProperties | undefined;
}) => {
  const map = useMap();
  const navigate = useNavigate();
  const { selecionarSigla } = useCamadas();
  const item = data[index];

  const irPara = () => {
    // As feições não trazem bbox: o enquadramento sai da própria geometria.
    try {
      const bounds = L.geoJSON(item.feature).getBounds();
      if (bounds.isValid()) map.flyToBounds(bounds, { animate: false });
    } catch {
      /* geometria inválida: segue sem reenquadrar */
    }

    selecionarSigla(item.sigla);

    // Só zona urbana tem ficha própria na API; área especial se resolve pela
    // consulta no ponto.
    if (item.origem === "zona") {
      navigate(`/consulta-previa/zonas/${encodeURIComponent(item.sigla)}`);
    }
  };

  return (
    <Flex
      style={style}
      alignItems="center"
      borderBottom="thin"
      borderBottomStyle="solid"
      borderBottomColor="gray.100"
      _dark={{ borderBottomColor: "gray.800" }}
      px="4"
      justifyContent="space-between"
      pointerEvents="auto"
    >
      <Box minW={0}>
        <Flex alignItems="center" gap="2">
          <Text fontWeight="medium" fontSize="md" noOfLines={1} lineHeight="5">
            {item.sigla}
          </Text>
          <Badge
            colorScheme={item.origem === "zona" ? "green" : "purple"}
            fontSize="0.6rem"
            flexShrink={0}
          >
            {item.origem === "zona" ? "Zona" : "Área especial"}
          </Badge>
        </Flex>
        <TextGray fontSize="xs" noOfLines={1}>
          {item.nome}
        </TextGray>
      </Box>
      <Box>
        <IconButtonGray
          variant="ghost"
          onClick={irPara}
          size="sm"
          icon={<RiArrowRightLine />}
          aria-label={`Ir para ${item.sigla}`}
        />
      </Box>
    </Flex>
  );
};
